import IconsComponent from '@/components/ui/icons/IconsComponent';

type CarouselDotsProps = {
  itemsLength: number;
  selectedIndex: number;
  onClick: (index: number) => void;
};
export const CarouselDots: React.FC<CarouselDotsProps> = ({
  itemsLength,
  selectedIndex,
  onClick,
}) => {
  const dots = Array.from({ length: itemsLength }, (_, index) => {
    const isSelected = index === selectedIndex;

    return (
      <button
        key={index}
        type='button'
        className='mx-2'
        onClick={() => onClick(index)}
        aria-label={`Go to slide ${index + 1}`}
      >
        {isSelected ? (
          <IconsComponent
            size='sm'
            icon='regular-next'
          />
        ) : (
          <span className='relative block h-3 w-3 rounded-full bg-[rgba(255,255,255,0.29)] transition-all duration-300 hover:bg-[rgba(255,255,255,0.5)]' />
        )}
      </button>
    );
  });

  return <div className='flex items-center justify-center'>{dots}</div>;
};
